import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TrophyIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="bg-emerald-900 py-16 sm:py-20" aria-labelledby="system-title" data-id="element-237" data-mp="3bhlk95796all">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-238" data-mp="36iqu1i6yhjrg">
        <span className="inline-flex items-center gap-2 text-balance rounded-md bg-amber-500 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-emerald-950" data-id="element-239" data-mp="31kpbcydfzmgi">
          <TrophyIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-240" data-mp="2wspcl993yzli" /> El sistema más completo de petróleo y gas para el aula
          de habla hispana
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-stone-50 sm:text-4xl" data-id="element-241" data-mp="2nudjn0krrppw">
          Megapack Petróleo y Gas Listo
        </h2>
        <p className="mt-3 font-semibold text-emerald-100" data-id="element-242" data-mp="2duuy4fp7nvvq">
          {totalVolumes} tomos · {totalBonuses} bonos estratégicos · Todo listo para usar desde hoy.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-243" data-mp="18py42q0mwvm7">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-emerald-700 bg-emerald-950 p-4 text-sm font-semibold text-stone-50" data-id="element-244" data-mp="u1tkljtrcg2d">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-245" data-mp="1csb7h7rwshft" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border-2 border-amber-500 bg-stone-50 p-6 text-left text-lg font-bold leading-relaxed text-emerald-950" data-id="element-246" data-mp="1hsfrv8vxtwbb">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-247" data-mp="69cymy6wg3xs" />
          Es un sistema para que entres al aula con confianza y dictes clases que de verdad enseñen cómo funciona la
          industria del petróleo y gas y cómo responder a las preguntas que tus alumnos tienen.
        </p>
      </div>
    </section>;
}